import React, { Component, Fragment } from 'react'
import { NavLink } from "react-router-dom";
import { IsAuthorize } from '../../../../shared/authorization/check-access';
import { Role } from '../../../../shared/authorization/enums';


interface IProps {
    id: number,
    url: string,
    name?:string,
    schemaName?:string,
    isSchema?:boolean
}
export  class ScopesTabs extends Component<IProps> {
    render() {
        return (
            <Fragment>
            <ul className="nav nav-tabs" id="myTab" role="tablist">
            {IsAuthorize([Role.TAM, Role.Dev, Role.Support]) &&<li className="nav-item">
                <NavLink to={"/scope/scope-form/" + this.props.id+"/"+this.props.schemaName} className={this.props.url=="/scope/scope-form/"?"nav-link active":"nav-link"} id="show-tab" data-toggle="tab" href="#edit" role="tab"
                    aria-controls="edit" aria-selected={this.props.url=="/scope/scope-form/"?"true":"false"}><i className="far fa-edit"></i>&nbsp;Edit</NavLink>
            </li>}
            {IsAuthorize([Role.TAM, Role.Dev, Role.Support]) &&  <li className="nav-item">
                    <NavLink to={"/scope/detail/" + this.props.id} className={this.props.url == "/scope/detail/" ? "nav-link active" : "nav-link"} id="detail-tab" data-toggle="tab" href="#edit" role="tab"
                        aria-controls="detail" aria-selected={this.props.url == "/scope/detail/" ? "true" : "false"}><i className="fas fa-info-circle"></i>&nbsp;Show</NavLink>
                </li>}
              {this.props.isSchema && IsAuthorize([Role.TAM, Role.Dev]) &&  <li className="nav-item">
                            <NavLink to={"/scope/schema-manager/" + this.props.id+"/"+this.props.name+"/"+this.props.schemaName} className={this.props.url == "/scope/schema-manager/" ? "nav-link active" : "nav-link"} id="connection-maintain-tab" data-toggle="tab" href="#connection-maintain" role="tab"
                                aria-controls="connection-maintain" aria-selected={this.props.url == "/scope/schema-manager/" ? "true" : "false"}><i className="fas fa-check"></i>&nbsp;Schema Manager</NavLink>
                        </li>}
            </ul>
            <br />
        </Fragment>
        )
    }
}
